export default "__VITE_ASSET__BGFMU9QM__"